import logout from "@/util/logout";
import store from "../../store/index";
import messages from "../../languages/index";
import hasNewCasino from "../../util/hasNewCasino";

let lang = localStorage.getItem("language") || store.state.language || "pt";
// ###
// OperatorType
// Retail 0 - Não tem agente, 100 % online (Não tem agentes, Arrecadador, só venda online)

// Retail 1 - Simplificado(Não tem rotas, Arrecadadores, Lançamentos, crédito,
//            na Prestação de contas não tem 'Apuração Rotas',
//            Rotas dos agentes)

// Retail 2 - Completo(Agentes, Arrecadadores, rotas...)
// ###
// ###
// Credit - Módulo Crédito
// Credit 1 - Vende crédito no dinheiro com o agente
// Credit 2 - Venda Crédito Online
// ###

var operatorType = localStorage.getItem("operator-retail");
var credit = localStorage.getItem("operator-credit");
let casino = localStorage.getItem("operator-casino");
const domain = localStorage.getItem("operator");
const operatorHasNewCasino = hasNewCasino.includes(domain);

const operator = {
  operatorType: operatorType,
  credit: credit,
  casino,
};

// // Debugg
// const operator = {
//   operatorType: 2,
//   credit: 1,
//   casino
// };
// console.log("operator na rota", operator)

export default {
  name: "administrator",
  path: "/administrator",
  redirect: {
    name: operator.credit == 2 ? "DashOnline" : "DashRetail",
  },
  meta: {
    requiresAuth: true,
    nameDrawer: messages[lang].administrator,
  },
  component: () => import("@/views/backoffice/template.vue"),
  beforeEnter: (to, from, next) => {
    const { level } = localStorage;
    level == "administrator" ? next() : logout();
  },
  children: [
    {
      name: "AdministratorDashboard",
      path: "dashboard",
      redirect: {
        name: operator.credit == 2 ? "DashOnline" : "DashRetail",
      },
      meta: {
        nameDrawer: "DashboardRouterView",
        active: true,
        icon: "mdi-view-dashboard",
        group: false,
        operator:
          operator.operatorType == 1 || operator.operatorType == 2
            ? true
            : false,
      },
      component: () => import("@/views/backoffice/administrator"),
    },

    // Dashboard Online
    {
      name: "DashOnline",
      path: "dashboard/online",
      meta: {
        nameDrawer: "Dashboard",
        typeDash: "online",
        active: true,
        icon: "mdi-view-dashboard",
        group: false,
        operator: operator.credit == 2 ? true : false,
        filterLimitDays: 31,
        isDash: true,
        hideRangeMenu: true,
      },
      component: () =>
        import("@/views/backoffice/administrator/dashboard/homeOnline.vue"),
    },
    // Dashboard Retail
    {
      name: "DashRetail",
      path: "dashboard/retail",
      meta: {
        nameDrawer: "Dashboard",
        typeDash: "retail",
        active: true,
        icon: "mdi-view-dashboard",
        group: false,
        operator:
          operator.operatorType == 1 || operator.operatorType == 2
            ? true
            : false,
      },
      component: () =>
        import("@/views/backoffice/administrator/dashboard/home.vue"),
    },

    // ========================================================================
    // ONLINE -
    // ========================================================================

    // ========================================================================
    // ONLINE/ BET -
    // ========================================================================

    {
      name: "AdministratorBets",
      path: "administratorBets",
      meta: {
        nameDrawer: `${messages[lang].bets} `,
        icon: "mdi-ticket-account",
        group: operator.casino != "0",
        operator: operator.credit == 2 ? true : false,
      },
      component: () => import("@/views/backoffice/administrator/online/bet/"),
      children: [
        // Chart Bets Online
        {
          name: "ChartOnline",
          path: "chartOnline",
          meta: {
            nameDrawer: messages[lang].sports,
            operator: operator.credit == 2 ? true : false,
            filters: ["Range", "SelectTypeBet"],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/administrator/online/bet/chartOnline"),
        },
        // List Bets Online
        {
          name: "AdministratorBetListPlayerOnline",
          path: "listBetsOnline",
          meta: {
            nameDrawer: messages[lang].report,
            operator: false,
            icon: "mdi-ticket-account",
            filters: [
              "Range",
              "AutocompletePlayers",
              "SelectStatusBet",
              "SelectTypeBet",
              "SelectResultBet",
              "Sinal",
              "SinalAward",
              "EventNumber",
              "GroupExport",
            ],
            filterLimitDays: 7,
          },
          component: () =>
            import("@/views/backoffice/administrator/online/bet/listOnline"),
        },
        // Casino Online Bets List
        {
          name: "CasinoListBetOnline",
          path: "casinoListBetOnline",
          meta: {
            nameDrawer: messages[lang].casino,
            operator:
              operator.credit == 2 && operatorHasNewCasino ? true : false,
            filters: [
              "Range",
              "SelectCasinoGroupBy",
              "SelectCasinoVerticalCategory",
              "AutocompleteProvidersByOperator",
              "AutocompleteCasinoCategories",
              "SelectCasinoLobby",
              "SelectTypeBetCasino",
            ],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/bet/newCasinoListBetOnline"
            ),
        },
        // New Casino Online Bets List
        {
          name: "NewCasinoListBetOnline",
          path: "newCasinoListBetOnline",
          meta: {
            hide: true,
          },
          redirect: {
            name: "CasinoListBetOnline",
          },
        },
      ],
    },

    // Affiliates
    {
      name: "AdministratorAffiliates",
      path: "administratorAffiliates",
      meta: {
        nameDrawer: messages[lang].affiliates,
        icon: "mdi-account-group",
        group: true,
        operator: operator.credit == 2 ? true : false,
      },
      component: () =>
        import("@/views/backoffice/administrator/online/affiliates/"),
      children: [
        {
          name: "AdministratorAffiliatesReports",
          path: "affiliatesReports",
          redirect: {
            name: "AdministratorOnlineExtract",
          },
          meta: {
            nameDrawer: messages[lang].reports,
            icon: "mdi-account-group",
            operator: operator.credit == 2 ? true : false,
          },
          component: () =>
            import("@/views/backoffice/administrator/online/affiliates/"),
          children: [
            // Affiliates Extract
            {
              name: "AdministratorOnlineExtract",
              path: "affiliates/adminOnlineOnlineExtract",
              redirect: {
                name: "AdministratorAffiliatesRevenueShare",
              },
              meta: {
                nameDrawer: messages[lang].extract,
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/online/affiliates/extractAndCpa/"
                ),
              children: [
                {
                  name: "AdministratorAffiliatesRevenueShare",
                  path: "revenueShare",
                  meta: {
                    nameDrawer: "Revenue Share",
                    filters: [
                      "Range",
                      "GamingType",
                      "GroupExport",
                      "HasInvoice",
                    ],
                    filterLimitDays: 31,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/extractAndCpa/extract/"
                    ),
                },
                {
                  name: "AdministratorAffiliatesCpa",
                  path: "cpa",
                  meta: {
                    nameDrawer: "CPA",
                    filters: [
                      "Range",
                      "AutocompleteRegionals",
                      "AutocompleteLocals",
                      "AutocompleteAgents",
                      "HasInvoice",
                      "GroupExport",
                    ],
                    filterLimitDays: 31,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/extractAndCpa/cpa/"
                    ),
                },
              ],
            },
            //
            //Affiliates - Regional Managers (Gerentes Regionais)
            {
              name: "AdministratorAffiliatesRegionalManagersList",
              path: "affiliates/regional-managers/list",
              meta: {
                nameDrawer: messages[lang].regionalManagers,
                operator:
                  operator.operatorType == 1 || operator.operatorType == 2
                    ? true
                    : false,
                filters: ["SelectStatus"],
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/online/affiliates/users/regional-managers/list"
                ),
              children: [
                {
                  name: "AdministratorOnlineAffiliatesRegionalManagersCreate",
                  path: "/regional-managers/create-regional-manager",
                  meta: {
                    nameDrawer: messages[lang].newRegionalManager,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/users/regional-managers/update"
                    ),
                },
                {
                  name: "AdministratorOnlineAffiliatesRegionalManagersEdit",
                  path: "/regional-managers/edit/:id",
                  meta: {
                    nameDrawer: messages[lang].editRegionalManager,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/users/regional-managers/update"
                    ),
                },
              ],
            },
            //
            // Affiliates -  Local Managers (Gerentes Locais)
            {
              name: "AdministratorAffiliatesLocalManagersList",
              path: "affiliates/local-managers/list",
              meta: {
                nameDrawer: messages[lang].localManagers,
                operator:
                  operator.operatorType == 1 || operator.operatorType == 2
                    ? true
                    : false,
                filters: ["AutocompleteRegionals", "SelectStatus"],
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/online/affiliates/users/local-managers/list"
                ),
              children: [
                {
                  name: "AdministratorOnlineAffiliatesUsersLocalManagersCreate",
                  path: "/local-managers/create-local-manager",
                  meta: {
                    nameDrawer: messages[lang].newLocalManager,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/users/local-managers/update"
                    ),
                },
                {
                  name: "AdministratorOnlineAffiliatesUsersLocalManagersEdit",
                  path: "/local-managers/edit/:id",
                  meta: {
                    nameDrawer: messages[lang].editLocalManager,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/users/local-managers/update"
                    ),
                },
              ],
            },
            //
            // Affiliates - Affiliates
            {
              name: "AdministratorAffiliatesAffiliatesList",
              path: "affiliates/affiliates/list",
              meta: {
                nameDrawer: messages[lang].affiliates,
                operator:
                  operator.operatorType == 1 || operator.operatorType == 2
                    ? true
                    : false,
                filters: [
                  "AutocompleteRegionals",
                  "AutocompleteLocals",
                  // 'AutocompleteAgents',
                  "SelectStatus",
                  "HasInvoice",
                ],
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/online/affiliates/users/affiliates/list"
                ),
              children: [
                {
                  name: "AdministratorOnlineAffiliatesUsersAffiliatesCreate",
                  path: "/affiliates/create-affiliate",
                  meta: {
                    nameDrawer: messages[lang].newAffiliate,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/users/affiliates/update"
                    ),
                },
                {
                  name: "AdministratorOnlineAffiliatesUsersAffiliatesEdit",
                  path: "/affiliates/edit/:id",
                  meta: {
                    nameDrawer: messages[lang].editAgent,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/users/affiliates/update"
                    ),
                },
                {
                  name:
                    "AdministratorOnlineAffiliatesUsersAffiliatesAnalyticalReport",
                  path: "/affiliates/report/:id/:name/:status",
                  meta: {
                    nameDrawer: messages[lang].analyticReport,
                    filterLimitDays: 31,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/online/affiliates/users/affiliates/AnalyticalReportByAffiliate.vue"
                    ),
                },
                {
                  name:
                    "AdministratorOnlineAffiliatesUsersLinkExemptPlayerAffiliates",
                  path: "/affiliates/link-exempt-player-affiliates",
                  meta: {
                    nameDrawer: messages[lang].linkExemptPlayerAffiliates,
                  },
                  component: () =>
                    import("@/components/common/dialog/LinkExemptPlayer"),
                },
                {
                  name:
                    "AdministratorOnlineAffiliatesUsersLinkAffiliateExemptPlayer",
                  path: "/affiliates/link-affiliate-exempt-player/:id",
                  meta: {
                    nameDrawer: messages[lang].linkAffiliateExemptPlayer,
                  },
                  component: () =>
                    import("@/components/common/dialog/LinkExemptPlayer"),
                },
              ],
            },
            //
            // Affiliates - Payments
            {
              name: "AdministratorAffiliatesPayments",
              path: "affiliates/affiliates/payments",
              meta: {
                nameDrawer: messages[lang].payments.tab,
                operator:
                  operator.operatorType == 1 || operator.operatorType == 2,
                filters: [
                  "AutocompleteRegionals",
                  "AutocompleteLocals",
                  "PaymentMonth",
                ],
              },
              beforeEnter: (to, from, next) => {
                if (to.name === "AdministratorAffiliatesPayments") {
                  next(
                    "/administrator/administratorAffiliates/affiliatesReports/affiliates/affiliates/payments/pay"
                  );
                } else {
                  next();
                }
              },
              component: () =>
                import("@/views/backoffice/shared/affiliates/payments/"),
              children: [
                {
                  name: "AdministratorAffiliatesPaymentsPay",
                  path: "pay",
                  meta: {
                    nameDrawer: messages[lang].payments.pay,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/shared/affiliates/payments/pay/"
                    ),
                },
                {
                  name: "AdministratorAffiliatesPaymentsHistoric",
                  path: "historic",
                  meta: {
                    nameDrawer: messages[lang].payments.historic,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/shared/affiliates/payments/historic/"
                    ),
                },
              ],
            },
          ],
        },
        {
          name: "AdministratorAffiliatesCampaings",
          path: "affiliatesCampaigns",
          meta: {
            nameDrawer: messages[lang].campaings,
            icon: "mdi-web-check",
            operator: operator.credit == 2 ? true : false,
            filters: [
              "Range",
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "SelectStatus",
            ],
            filterLimitDays: 31,
          },
          component: () => import("@/views/backoffice/shared/campaings/"),
        },
      ],
    },
    // PLAYERS ONLINE
    {
      name: "AdministratorPlayers",
      path: "administratorPlayers",
      meta: {
        nameDrawer: `${messages[lang].players}`,
        icon: "mdi-account",
        operator: operator.credit == 2 ? true : false,
      },
      component: () =>
        import("@/views/backoffice/administrator/online/users/players/"),
      children: [
        // Players (Jogadores) Online
        {
          name: "AdministratorAccountabilityOnlinePlayersOnlineSearch",
          path: "playerOnlineSearch",
          meta: {
            nameDrawer: messages[lang].search,
            operator: operator.credit == 2 ? true : false,
            group: false,
            filters: ["AutocompletePlayers"],
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/users/players/searchOnline"
            ),
          children: [
            {
              name: "AdministratorPlayerOnlinelistBets",
              path: "playerOnlinelistBets",
              meta: {
                nameDrawer: messages[lang].listBets,
                hide: true,
                filters: [
                  "Range",
                  "SelectStatusBet",
                  "SelectResultBet",
                  "Sinal",
                ],
                filterLimitDays: 31,
              },
            },
            {
              name: "AdministratorListCreditsOnline",
              path: "listCreditsOnline",
              meta: {
                nameDrawer: messages[lang].listCredits,
                hide: true,
                filters: ["Range", "GroupStatus"],
                filterLimitDays: 31,
              },
            },
            {
              name: "AdministratorTransferForOnlinePlayer",
              path: "transferForOnlinePlayer",
              meta: {
                nameDrawer: messages[lang].depositForPlayer,
                hide: true,
                filters: [
                  // "Range",
                  // "GroupStatus"
                ],
                filterLimitDays: 31,
              },
            },
            {
              name: "AdministratorOnlinePlayerReleases",
              path: "releasesOnline",
              meta: {
                nameDrawer: messages[lang].releases,
                hide: true,
                filters: [
                  "Range",
                  // "GroupStatus"
                ],
                filterLimitDays: 31,
              },
            },
            {
              name: "AdministratorConfigOnline",
              path: "configOnline",
              meta: {
                nameDrawer: `${messages[lang].configuration} `,
                hide: true,
              },
            },
            {
              name: "AdministratorAnalyticalReportPlayer",
              path: "reportPlayer",
              meta: {
                nameDrawer: `${messages[lang].analyticReport} `,
                filters: ["GroupExport"],
                filterLimitDays: 31,
              },
            },
          ],
        },
        // List Players Online
        {
          name: "ListPlayersOnline",
          path: "listPlayersOnline",
          meta: {
            nameDrawer: messages[lang].playersList,
            operator: operator.credit == 2 ? true : false,
            filters: [
              "Range",
              "SelectStatusPlayers",
              "Sinal",
              "SinalDeposit",
              "GroupExport",
              "DepositValue",
              "AutocompleteAgents",
            ],
            filterLimitDays: 15,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/users/players/listPlayersOnline"
            ),
        },
        // List Players Inactive
        {
          name: "PlayersOnlineInactives",
          path: "playersOnlineInactives",
          meta: {
            nameDrawer: messages[lang].inactivePlayers,
            operator: operator.credit == 2 ? true : false,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/users/players/playersOnlineInactives"
            ),
        },
        // Total Online Balance
        {
          name: "TotalOnlineBalance",
          path: "totalOnlineBalance",
          meta: {
            nameDrawer: messages[lang].totalOnlineBalance,
            operator: operator.credit == 2,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/users/players/totalOnlineBalance"
            ),
        },
        // Aprovar documentos negados
        {
          name: "DocumentVerification",
          path: "documentVerification",
          meta: {
            nameDrawer: messages[lang].documentVerification,
            operator: operator.credit == 2,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/users/players/documentVerification"
            ),
        },
        // Tags Config
        {
          name: "TagsConfig",
          path: "tagsConfig",
          meta: {
            nameDrawer: messages[lang].tagsConfig,
            operator: operator.credit == 2,
          },
          component: () =>
            import("@/views/backoffice/shared/users/players/tagsConfig"),
        },
      ],
    },

    //  =================================================================
    //  Group: Deposits and Withdraws
    //  =================================================================
    {
      name: "BankOnline",
      path: "withdrawsAndDeposits",
      meta: {
        nameDrawer: messages[lang].depositsAndWithdrawals,
        icon: "mdi-bank-transfer",
        operator: operator.credit == 2 ? true : false,
        group: false,
        filterLimitDays: 31,
      },
      component: () =>
        import(
          "@/views/backoffice/administrator/online/accountabilityOnline/withdrawsAndDeposits"
        ),
      children: [
        // Tab - Extract
        {
          name: "AdministratorAccountabilityOnlineBankStatement",
          path: "bankStatement",
          meta: {
            nameDrawer: messages[lang].extract,
            filters: ["Range", "PaymentProvider"],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/accountabilityOnline/bankStatement"
            ),
        },
        // Tab - By user - Extract Per user
        {
          name: "BankStatementByUser",
          path: "bankStatementByUser",
          meta: {
            nameDrawer: messages[lang].extractByUser,
            filters: ["Range", "PaymentProvider"],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/accountabilityOnline/bankStatementByUser"
            ),
        },
        // Tab - Deposits
        {
          name: "AdministratorAccountabilityOnlineDeposits",
          path: "listDeposits",
          meta: {
            nameDrawer: messages[lang].deposits,
            filters: [
              "Range",
              "SelectTypeBankStatement",
              "PaymentProvider",
              "GroupExport",
            ],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/accountabilityOnline/listDeposits"
            ),
        },
        // Tab - Withdraws
        {
          name: "ListWithdraws",
          path: "listWithdraws",
          meta: {
            nameDrawer: messages[lang].withdrawals,
            filters: [
              "Range",
              "SelectTypeBankStatement",
              "PaymentProvider",
              "GroupExport",
            ],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/accountabilityOnline/listWithdraws"
            ),
        },
      ],
    },
    //  =================================================================
    //  Group: Bonus
    //  =================================================================
    {
      name: "BonusAndPromotions",
      path: "bonusAndPromotions",
      meta: {
        nameDrawer: messages[lang].PromotionsAndbonus,
        icon: "mdi-seal-variant",
        operator: operator.credit == 2 ? true : false,
        group: false,
        filterLimitDays: 31,
      },
      component: () =>
        import(
          "@/views/backoffice/administrator/online/bonus/bonusAndPromotions"
        ),
      children: [
        {
          name: "ListPromotionOnline",
          path: "listPromotionOnline",
          meta: {
            nameDrawer: messages[lang].promotions,
            operator: operator.credit == 2 ? true : false,
            filters: ["SelectStatus"],
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/bonus/listPromotionOnline"
            ),
          children: [
            {
              name: "ListAdhesions",
              path: "listAdhesions",
              // redirect: { name: "ListPromotionOnline" },
              meta: {
                nameDrawer: messages[lang].adhesions,
                operator: operator.credit == 2 ? true : false,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/online/bonus/dialogListAdhesions"
                ),
            },
            {
              name: "ExportPromotionTokens",
              path: "exportPromotionTokens",
              meta: {
                nameDrawer: messages[lang].exportTokens,
                operator: operator.credit == 2 ? true : false,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/online/bonus/exportPromotionTokens"
                ),
            },
          ],
        },
        {
          name: "AdministratorListBonusOnline",
          path: "listBonusOnline",
          meta: {
            nameDrawer: messages[lang].bonus, // Lista de Status de bônus Online

            icon: "mdi-seal-variant",
            operator: operator.credit == 2 ? true : false,
            group: false,
            filters: ["Range", "BonusReportType", "GroupExport", "SelectSport"],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/bonus/listBonusOnline"
            ),
        },
        {
          name: "AdministratorFreespins",
          path: "freespins",
          meta: {
            nameDrawer: messages[lang].promotions,
            operator: operator.credit == 2 ? true : false,
            filters: ["SelectStatus"],
          },
          component: () =>
            import("@/views/backoffice/shared/bonusAndPromotions/freespins"),
        },
      ],
    },
    //  =================================================================
    //  Group: Config Cassino
    //  =================================================================
    {
      name: "Casino",
      path: "configCasino",
      meta: {
        nameDrawer: messages[lang].casino,
        icon: "mdi-slot-machine-outline",
        // icon: "mdi-dice-multiple-outline",
        operator:
          operator.credit == 2 && operator.casino != 0 && operatorHasNewCasino
            ? true
            : false,
        group: true,
        // filterLimitDays: 31,
      },
      component: () =>
        import("@/views/backoffice/administrator/online/casino/casino.vue"),
      children: [
        {
          name: "ListCategories",
          path: "listCategories",
          meta: {
            nameDrawer: messages[lang].categories,
            operator: operator.credit == 2 ? true : false,
            filters: [
              "SelectCasinoLobby",
              // "SelectCasinoVerticalCategory",
              // "SelectCasinoTheme"
            ],
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/casino/listCategories.vue"
            ),
        },
        {
          name: "ListGames",
          path: "listGames",
          meta: {
            nameDrawer: messages[lang].games,
            operator: operator.credit == 2 ? true : false,
            filters: [
              "AutocompleteProvidersByOperator",
              "AutocompleteCasinoCategories",
              "SelectCasinoVerticalCategory",
              "SelectCasinoTheme",
              "SelectCasinoLobby",
            ],
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/casino/listGames.vue"
            ),
        },
      ],
    },
    //  =================================================================
    //  Group: Config Online
    //  =================================================================
    {
      name: "ConfigOnline",
      path: "configOnline",
      meta: {
        nameDrawer: `${messages[lang].configuration} `,
        icon: "mdi-cog",
        operator: operator.credit == 2,
        group: operator.credit == 2,
      },
      component: () =>
        import("@/views/backoffice/administrator/online/settings/index"),
      children: [
        // General Settings
        {
          name: "GeneralOnlineConfiguration",
          path: "general",
          meta: {
            nameDrawer: "Geral",
            operator: operator.credit == 2,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/settings/configOnline"
            ),
        },
        // Payment Settings
        {
          name: "PaymentProviderConfiguration",
          path: "paymentProviders",
          meta: {
            nameDrawer: "Pagamento",
            operator: operator.credit == 2,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/online/settings/paymentProviders"
            ),
        },
        // Casino Settings
        {
          name: "CasinoSettings",
          path: "casinoSettings",
          meta: {
            nameDrawer: messages[lang].casino,
            operator: operator.casino != 0 && !operatorHasNewCasino,
          },
          component: () =>
            import("@/views/backoffice/administrator/settings/casino.vue"),
        },
        {
          name: "Webhooks",
          path: "webhooks",
          meta: {
            nameDrawer: "Webhooks",
            operator: operator.credit == 2,
          },
          component: () => import("@/views/backoffice/shared/webhooks"),
        },
      ],
    },

    // Documents
    {
      name: "documents",
      path: "documents",
      meta: {
        nameDrawer: messages[lang].documents,
        operator: operator.credit == 2,
        group: false,
        icon: "mdi-file-document",
      },
      component: () =>
        import("@/views/backoffice/administrator/system/documents.vue"),
    },

    // Group REDE:
    //  =================================================================
    //  Group: Bet
    //  =================================================================
    {
      name: "AdministratorBet",
      path: "bet",
      meta: {
        nameDrawer: messages[lang].bets,
        icon: "mdi-ticket-confirmation",
        group: true,
        operator:
          operator.operatorType == 1 || operator.operatorType == 2
            ? true
            : false,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratorBetListOnline",
          path: "listOnline",
          meta: {
            nameDrawer: messages[lang].bets,
            operator: operator.credit == 1 ? true : false,
            filters: [
              "Range",
              "AutocompletePlayers",
              "SelectStatusBet",
              "SelectResultBet",
              "Sinal",
              "EventNumber",
              "GroupExport",
            ],
            filterLimitDays: 7,
          },
          component: () =>
            import("@/views/backoffice/administrator/online/bet/listOnline"),
        },
        {
          name: "AdministratorBetList",
          path: "list",
          meta: {
            nameDrawer: messages[lang].betsPDV,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: [
              "Range",
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "SelectResultBet",
              "Sinal",
              "SinalAward",
              "GroupOriginBet",
              "EventNumber",
              "GroupExport",
            ],
          },
          component: () => import("@/views/backoffice/administrator/bet/list"),
        },
        {
          name: "AdministratorBetCancel",
          path: "cancel",
          meta: {
            nameDrawer: messages[lang].cancelledBets,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: [
              "Range",
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "EventNumber",
              "GroupExport",
            ],
          },
          component: () =>
            import("@/views/backoffice/administrator/bet/cancel"),
        },
      ],
    },
    {
      name: "AdministratorAgentBetList",
      path: "list/agent",
      meta: {
        nameDrawer: messages[lang].betsPDV,
        operator:
          operator.operatorType == 1 || operator.operatorType == 2
            ? true
            : false,
        filters: [
          "Range",
          "SelectResultBet",
          "AutocompleteAgents",
          "Sinal",
          "SinalAward",
          "GroupOriginBet",
          "EventNumber",
          "GroupExport",
        ],
        filterLimitDays: 7,
      },
      component: () => import("@/views/backoffice/administrator/bet/list"),
    },

    //  =================================================================
    //  Group: Credit
    //  =================================================================
    {
      name: "AdministratorCredit",
      path: "credit",
      meta: {
        nameDrawer: messages[lang].credit,
        icon: "mdi-credit-card-outline",
        group: true,
        operator: operator.operatorType == 2 ? true : false,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratorCreditHistoric",
          path: "historic",
          meta: {
            nameDrawer: messages[lang].historic,
            operator: operator.operatorType == 2 ? true : false,
            filters: [
              "Range",
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "GroupStatus",
            ],
          },
          component: () =>
            import("@/views/backoffice/administrator/credit/historic"),
        },
      ],
    },

    //  =======================================================================
    //  Group: Users Regionals, Locals, Agents, Collectors, Routes and Players.
    //  =======================================================================
    {
      name: "AdministratorUsers",
      path: "users",
      meta: {
        nameDrawer: messages[lang].users,
        icon: "mdi-account-multiple",
        group: true,
        operator:
          operator.operatorType == 1 || operator.operatorType == 2
            ? true
            : false,
      },
      component: () => import("@/views/backoffice/administrator"),
      children: [
        //
        // Regional Managers (Gerentes Regionais)
        {
          name: "AdministratorUsersRegionalManagersList",
          path: "regional-managers/list",
          meta: {
            nameDrawer: messages[lang].regionalManagers,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: ["SelectStatus"],
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/users/regional-managers/list"
            ),
          children: [
            {
              name: "AdministratorUsersRegionalManagersCreate",
              path: "create-regional-manager",
              meta: {
                nameDrawer: messages[lang].newRegionalManager,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/regional-managers/update"
                ),
            },
            {
              name: "AdministratorUsersRegionalManagersEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editRegionalManager,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/regional-managers/update"
                ),
            },
          ],
        },
        //
        // Local Managers (Gerentes Locais)
        {
          name: "AdministratorUsersLocalManagersList",
          path: "local-managers/list",
          meta: {
            nameDrawer: messages[lang].localManagers,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: ["AutocompleteRegionals", "SelectStatus"],
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/users/local-managers/list"
            ),
          children: [
            {
              name: "AdministratorUsersLocalManagersCreate",
              path: "create-local-manager",
              meta: {
                nameDrawer: messages[lang].newLocalManager,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/local-managers/update"
                ),
            },
            {
              name: "AdministratorUsersLocalManagersEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editLocalManager,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/local-managers/update"
                ),
            },
          ],
        },
        //
        // Agents (Agentes)
        {
          name: "AdministratorUsersAgentsList",
          path: "agents/list",
          meta: {
            nameDrawer: messages[lang].agents,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: [
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "SelectStatus",
            ],
          },
          component: () =>
            import("@/views/backoffice/administrator/users/agents/list"),
          children: [
            {
              name: "AdministratorUsersAgentsCreate",
              path: "create-agent",
              meta: {
                nameDrawer: messages[lang].newAgent,
              },
              component: () =>
                import("@/views/backoffice/administrator/users/agents/update"),
            },
            {
              name: "AdministratorUsersAgentsEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editAgent,
              },
              component: () =>
                import("@/views/backoffice/administrator/users/agents/update"),
            },
            {
              name: "AdministratorUsersAgentsEditComissionsBets",
              path: "comissions-bets/:id",
              meta: {
                nameDrawer: messages[lang].agentBettingCommision,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/agents/comissionsBets"
                ),
            },
          ],
        },
        //
        // Collectors (Arrecadadores)
        {
          name: "AdministratorUsersCollectorsList",
          path: "collectors/list",
          meta: {
            nameDrawer: messages[lang].collectors,

            operator: operator.operatorType == 2 ? true : false,
            filters: ["AutocompleteRegionals"],
          },
          component: () =>
            import("@/views/backoffice/administrator/users/collectors/list"),
          children: [
            {
              name: "AdministratorUsersCollectorsCreate",
              path: "create-route",
              meta: {
                nameDrawer: messages[lang].newCollector,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/collectors/update"
                ),
            },
            {
              name: "AdministratorUsersCollectorsEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editCollector,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/collectors/update"
                ),
            },
            {
              name: "AdministratorUsersCollectorsRoutesToCollect",
              path: "routesToCollect/:id_collector",
              meta: {
                nameDrawer: messages[lang].routesToCollect,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/collectors/routesToCollect"
                ),
            },
          ],
        },
        //
        // Routes (Rotas)
        {
          name: "AdministratorUsersRoutesList",
          path: "routes/list",
          meta: {
            nameDrawer: messages[lang].routes,
            operator: operator.operatorType == 2 ? true : false,
            filters: ["AutocompleteRegionals"],
          },
          component: () =>
            import("@/views/backoffice/administrator/users/routes/list"),
          children: [
            {
              name: "AdministratorUsersRoutesCreate",
              path: "create-route",
              meta: {
                nameDrawer: messages[lang].routes,
              },
              component: () =>
                import("@/views/backoffice/administrator/users/routes/update"),
            },
            {
              name: "AdministratorUsersRoutesEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editRoute,
              },
              component: () =>
                import("@/views/backoffice/administrator/users/routes/update"),
            },
          ],
        },
        //
        // Players (Jogadores)
        {
          name: "AdministratorUsersPlayersSearch",
          path: "players/search",
          meta: {
            nameDrawer: messages[lang].players,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: [
              // AutocompletePlayers - Perfil, ListBets e ListCredits
              "AutocompletePlayers",
              // Range - ListBets e ListCredits
              // SelectStatusBet, SelectResultBet e Sinal - ListBets
              // GroupStatus - ListCredits
              // "Range",
              // "SelectStatusBet",
              // "SelectResultBet",
              // "Sinal",
              // "GroupStatus"
            ],
          },
          component: () =>
            import("@/views/backoffice/administrator/users/players/search"),
          //
          // Rotas Obsoletas
          // ===============
          // children: [{
          //   name: "AdministratorUsersPlayersSearchListBets",
          //   path: "listBets",
          //   meta: {
          //     nameDrawer: messages[lang].listBets,
          //     hide: true,
          //     filters: [
          //       "Range",
          //       "SelectStatusBet",
          //       "SelectResultBet",
          //       "Sinal",
          //     ]
          //   },
          // },
          // {
          //   name: "AdministratorUsersPlayersSearchListCredits",
          //   path: "listCredits",
          //   meta: {
          //     nameDrawer: messages[lang].listCredits,
          //     hide: true,
          //     filters: [
          //       "Range",
          //       "GroupStatus"
          //     ],
          //   },
          // },
          // {
          //   name: "AdministratorUsersPlayersSearchConfig",
          //   path: "config",
          //   meta: {
          //     nameDrawer: messages[lang].configuration,
          //     hide: true,
          //   },
          // }
          // ],
          // ===============
        },
      ],
    },
    //  =======================================================================
    //  Group: Areas
    //  =======================================================================
    {
      name: "AdministratorAreas",
      path: "areas",
      meta: {
        nameDrawer: messages[lang].areas,

        icon: "mdi-map-marker",
        group: true,
        operator: operator.operatorType != 0,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratoAreasList",
          path: "list",
          meta: {
            nameDrawer: messages[lang].listAreas,

            operator: true,
          },
          component: () =>
            import("@/views/backoffice/administrator/areas/list"),
          children: [
            {
              name: "AdministratoAreasListCreate",
              path: "create-area",
              meta: {
                nameDrawer: messages[lang].newArea,
              },
              component: () =>
                import("@/views/backoffice/administrator/areas/update"),
            },
            {
              name: "AdministratoAreasListEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].newArea,
              },
              component: () =>
                import("@/views/backoffice/administrator/areas/update"),
            },
          ],
        },
      ],
    },
    //  =======================================================================
    //  Group: Relatório
    //  =======================================================================

    {
      name: "AdministratorReports",
      path: "reports",
      meta: {
        nameDrawer: messages[lang].reports,
        operator: true,
        icon: "mdi-chart-bar",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratoReportsBetList",
          path: "list",
          meta: {
            nameDrawer: messages[lang].eventsBetting,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/administrator/reports/reportBetEvents"),
        },
        {
          name: "AdministratoReportDefends",
          path: "defends",
          meta: {
            nameDrawer: messages[lang].defense,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/administrator/reports/defends"),
        },
        {
          name: "AdministratorReportsUsers",
          path: "reportUsers",
          meta: {
            nameDrawer: messages[lang].users,
            hide: operator.credit != 2,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () => import("@/views/backoffice/shared/reports/users"),
        },
        {
          name: "AdministratorReportsSportBets",
          path: "reportSportBets",
          meta: {
            nameDrawer: messages[lang].bets,
            hide: operator.credit != 2,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 15,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/sportsbookBet"),
        },
        {
          name: "AdministratorReportsCasinoBets",
          path: "reportCasinoBets",
          meta: {
            nameDrawer: messages[lang].casino,
            operator: operator.credit == 2,
            hide: operator.credit != 2,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/casinoBet"),
          beforeEnter(to, from, next) {
            if (operator.credit == 2) {
              next();
            } else {
              next("/");
            }
          },
        },
        {
          name: "AdministratorReportsDeposits",
          path: "reportDeposits",
          meta: {
            nameDrawer: messages[lang].deposits,
            hide: operator.credit != 2,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () => import("@/views/backoffice/shared/reports/deposits"),
        },
        {
          name: "AdministratorReportsWithdrawals",
          path: "reportWithdrawals",
          meta: {
            nameDrawer: messages[lang].withdrawals,
            hide: operator.credit != 2,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/withdrawals"),
        },
      ],
    },
    //  =======================================================================
    //  Group: Collaborators
    //  =======================================================================
    {
      name: "AdministratorCollaborators",
      path: "collaborators",
      meta: {
        nameDrawer: messages[lang].collaborators,

        icon: "mdi-account-star",
        group: true,
        operator: operator.credit == 2,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratorCollaboratorPermissions",
          path: "list-permissions",
          meta: {
            nameDrawer: messages[lang].listPermissions,
            operator: true,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/users/collaborators/listPermissions.vue"
            ),
          children: [
            {
              name: "AdministratorCreatePermissionsGroup",
              path: "create-permissions-group",
              meta: {
                nameDrawer: messages[lang].createPermissionsGroup,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/collaborators/updatePermissions.vue"
                ),
            },
            {
              name: "AdministratorEditPermissionsGroup",
              path: "edit-permissions-group",
              meta: {
                nameDrawer: messages[lang].updatePermissions,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/collaborators/updatePermissions.vue"
                ),
            },
          ],
        },
        {
          name: "AdministratorListCollaborator",
          path: "administratorListCollaborator",
          meta: {
            nameDrawer: messages[lang].listCollaborators,
            operator: true,
            filters: ["SelectStatus"],
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/users/collaborators/listCollaborator.vue"
            ),
          children: [
            {
              name: "AdministratorCreateCollaborator",
              path: "create-collaborator",
              meta: {
                nameDrawer: messages[lang].newCollaborator,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/collaborators/updateCollaborator.vue"
                ),
            },
            {
              name: "AdministratorEditCollaborator",
              path: "edit-collaborator",
              meta: {
                nameDrawer: messages[lang].editCollaborator,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/users/collaborators/updateCollaborator.vue"
                ),
            },
          ],
        },
      ],
    },
    //  =======================================================================
    //  Group: Financial
    //  =======================================================================
    {
      name: "AdministratorFinancial",
      path: "administratorFinancial",
      meta: {
        nameDrawer: messages[lang].accountability,
        // icon: "mdi-cash-usd-outline", // Old Icons
        icon: "mdi-currency-usd",
        operator:
          operator.operatorType == 2 || operator.operatorType == 1
            ? true
            : false,
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        // {
        //   name: "AdministratorFinancialSalesReportCollectors",
        //   path: "sales-report-collectors",
        //   meta: {
        //     nameDrawer: "Apuração Arrecadadores",
        //     filters: [
        //       "Range",
        //       "AutocompleteRegionals",
        //       "AutocompleteCollectors",
        //       "AutocompleteAgents",
        //       "GroupStatus"
        //     ],
        //   },
        //   component: () => import('@/views/backoffice/administrator/financial/salesReportCollectors'),
        // },
        // Apuração Geral
        {
          name: "AdministratorFinancialSalesReport",
          path: "sales-report",
          meta: {
            nameDrawer: messages[lang].generalFinding,
            fluid: true,
            operator: true,
            filters: [
              "Range",
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "GroupTypeLive",
              "GroupExport",
            ],
            filterLimitDays: 31,
          },
          // component: () => import("@/views/backoffice/administrator/financial/salesReport"),
          component: () =>
            new Promise((resolve) => {
              operator.operatorType == 2
                ? resolve(
                    import(
                      "@/views/backoffice/administrator/financial/salesReport"
                    )
                  )
                : resolve(
                    import(
                      "@/views/backoffice/administrator/financial/salesReportSimplified"
                    )
                  );
              // store.state.operator.retail == 2 ?
              //   resolve(import("@/views/backoffice/administrator/financial/salesReport")) :
              //   resolve(import("@/views/backoffice/administrator/financial/salesReportSimplified"))
            }),
        },

        // Apuração Area
        {
          name: "AdministratorFinancialSalesReportArea",
          path: "sales-report-area",
          meta: {
            nameDrawer: messages[lang].areaFinding,
            fluid: true,
            operator: true,
            filters: [
              "Range",
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
            ],
            filterLimitDays: 31,
          },
          component: () =>
            new Promise((resolve) => {
              operator.operatorType == 2
                ? resolve(
                    import(
                      "@/views/backoffice/administrator/financial/salesReportArea"
                    )
                  )
                : resolve(
                    import(
                      "@/views/backoffice/administrator/financial/salesReportAreaSimplified"
                    )
                  );
              // store.state.operator.retail == 2 ? resolve(import("@/views/backoffice/administrator/financial/salesReportArea")) :
              //   resolve(import("@/views/backoffice/administrator/financial/salesReportAreaSimplified"))
            }),
        },
        // Apuração Rota
        {
          name: "AdministratorFinancialSalesReportRoute",
          path: "sales-report-route",
          meta: {
            nameDrawer: messages[lang].routesFinding,
            fluid: true,
            operator: operator.operatorType == 2 ? true : false,
            filters: [
              "Range",
              "AutocompleteRegionals",
              // "AutocompleteAgents",
              "AutocompleteRoutes",
              "GroupTypeLive",
              "GroupExport",
            ],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/financial/salesReportRoute"
            ),
        },
        {
          name: "AdministratorFinancialAgents",
          path: "agents",
          meta: {
            nameDrawer: messages[lang].agents,
            operator: operator.operatorType == 2 ? true : false,
            hide: true,
            subGroup: true,
          },
          component: () => import("@/views/backoffice/administrator"),
          children: [
            // Balanço
            {
              name: "AdministratorFinancialBalance",
              path: "balance",
              meta: {
                nameDrawer: messages[lang].balanceLabel,
                operator:
                  operator.operatorType == 2 || operator.operatorType == 1
                    ? true
                    : false,
                filters: [
                  "AutocompleteRegionals",
                  "AutocompleteLocals",
                  // "AutocompleteAgents"
                ],
                filterLimitDays: 31,
              },
              component: () =>
                import("@/views/backoffice/administrator/financial/balance"),
              children: [
                {
                  name: "AdministratorFinancialBalanceInsertEntryDeal",
                  path: "insertEntryDeall/:id_agente",
                  meta: {
                    nameDrawer: messages[lang].agentRelease,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/financial/insertEntryDeal"
                    ),
                },
              ],
            },
            // Balanço por rotas
            {
              name: "AdministratorFinancialBalanceRoute",
              path: "balance-route",
              meta: {
                nameDrawer: messages[lang].balanceByRoute,
                operator: operator.operatorType == 2 ? true : false,
                filters: [
                  "AutocompleteRoutes",
                  "AutocompleteRegionals",
                  // "AutocompleteAgents",
                ],
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/financial/listBalanceRoute"
                ),
              children: [
                {
                  name: "AdministratorFinancialBalanceRouteInsertEntryDeal",
                  path: "insertEntryDealRoute/:id_agente",
                  meta: {
                    nameDrawer: messages[lang].agentRelease,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/financial/insertEntryDeal"
                    ),
                },
              ],
            },
            // Lançamentos
            {
              name: "AdministratorFinancialLaunches",
              path: "launches",
              meta: {
                nameDrawer: messages[lang].closings,

                operator: true,
                filters: [
                  "Range",
                  "AutocompleteRegionals",
                  "AutocompleteLocals",
                  "AutocompleteCollectors",
                  "SelectFinancialCategoryAgent",
                ],
                filterLimitDays: 31,
              },
              component: () =>
                import("@/views/backoffice/administrator/financial/launches"),
            },
          ],
        },
        {
          name: "AdministratorFinancialCollectors",
          path: "collectors",
          meta: {
            nameDrawer: messages[lang].collectors,
            operator: operator.operatorType == 2 ? true : false,
            hide: true,
            subGroup: true,
          },
          component: () => import("@/views/backoffice/administrator"),
          children: [
            // Fechamentos
            {
              name: "AdministratorFinancialCashCollectors",
              path: "cash-collectors",
              meta: {
                nameDrawer: messages[lang].closings,
                operator: true,
                filters: [
                  "Range",
                  "AutocompleteRegionals",
                  "AutocompleteCollectors",
                ],
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/financial/cashCollectors"
                ),
            },
          ],
        },
      ],
    },

    //  =======================================================================
    //  Group: Events
    //  =======================================================================
    {
      name: "AdministratorEvents",
      path: "events",
      meta: {
        nameDrawer: messages[lang].events,
        operator: true,
        icon: "mdi-trophy-outline",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratorEventsList",
          path: "list",
          meta: {
            nameDrawer: messages[lang].events,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            // filters: ["SelectStatusEvents",]
          },
          component: () =>
            import("@/views/backoffice/administrator/events/list"),
          children: [
            {
              name: "AdministratorEventEditOdds",
              path: "event/:id",
              meta: {
                nameDrawer: messages[lang].editOdd,
              },
              component: () =>
                import("@/views/backoffice/administrator/events/editOdds"),
            },
            {
              name: "BetPlacedReport",
              path: "betPlacedReport",
              meta: {
                nameDrawer: messages[lang].betPlacedReport,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/events/betPlacedReport"
                ),
            },
            {
              name: "AdministratorMarketReportByEvent",
              path: "event/:id",
              component: () =>
                import(
                  "@/views/backoffice/administrator/events/marketReportByEvent"
                ),
            },
          ],
        },
        {
          name: "AdministratorMainEvents",
          path: "mainEvents",
          meta: {
            nameDrawer: messages[lang].mainEvents,
            operator: operator.credit == 2,
          },
          component: () =>
            import("@/views/backoffice/administrator/events/mainEvents"),
        },
        {
          name: "AdministratorCreatedEvents",
          path: "createdEvents",
          meta: {
            nameDrawer: messages[lang].createNewEvent.drawer,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/shared/events/createdEvents/list"),
        },
      ],
    },

    //  =================================================================
    //  Group: Configuração
    //  =================================================================
    {
      name: "AdministratorSettings",
      path: "settings",
      meta: {
        nameDrawer: messages[lang].configuration,
        operator: true,
        icon: "mdi-wrench",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratorSettingsInstitutional",
          path: "institutional",
          meta: {
            nameDrawer: messages[lang].institutional,
            operator: true,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/settings/institutional.vue"
            ),
        },
        {
          name: "AdministratorSettingsBank",
          path: "bank",
          meta: {
            nameDrawer: messages[lang].bankConfiguration,

            operator: true,
          },
          component: () =>
            import("@/views/backoffice/administrator/settings/bank.vue"),
        },
        {
          name: "AdministratorSettingsLeagues",
          path: "leagues",
          meta: {
            nameDrawer: messages[lang].manageLeagues,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/administrator/settings/leagues.vue"),
        },
        {
          name: "AdministratorSettingsMarketsMargins",
          path: "markets-margin",
          meta: {
            nameDrawer: messages[lang].marketsAndMargins,
            operator: true,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/settings/markets-margin.vue"
            ),
        },
        // ========================================================
        // Media-settings(Gerenciar Mídias) - Mídias e Landing Page
        // ========================================================
        // {
        //   name: "AdministratorSettingsMedia",
        //   path: "media-settings",
        //   meta: {
        //     nameDrawer: messages[lang].manageMedia,
        //     operator: true,
        //     hide: true,
        //     subGroup: true,
        //   },
        //   component: () =>
        //     import(
        //       "@/views/backoffice/administrator/settings/mediaSettings.vue"
        //     ),
        //   children: [
        //     {
        //       name: "AdministratorMedia",
        //       path: "media",
        //       meta: {
        //         nameDrawer: messages[lang].medias,
        //         operator: true,
        //       },
        //       component: () =>
        //         import("@/views/backoffice/administrator/settings/media.vue"),
        //     },
        //     {
        //       name: "AdministratorLandingPage",
        //       path: "landing-page",
        //       meta: {
        //         nameDrawer: messages[lang].landingPage,
        //         operator:
        //           operator.operatorType == 2 || operator.operatorType == 1
        //             ? true
        //             : false,
        //       },
        //       component: () =>
        //         import(
        //           "@/views/backoffice/administrator/settings/landingPage.vue"
        //         ),
        //       // children: [
        //       //   {
        //       //     name: "AdministratorFinancialBalanceInsertEntryDeal",
        //       //     path: "insertEntryDeall/:id_agente",
        //       //     meta: {
        //       //       nameDrawer: messages[lang].agentRelease,
        //       //     },
        //       //     component: () =>
        //       //       import(
        //       //         "@/views/backoffice/administrator/financial/insertEntryDeal"
        //       //       ),
        //       //   },
        //       // ],
        //     },
        //   ],
        // },
      ],
    },
    //  =================================================================
    //  Group: System
    //  =================================================================
    {
      name: "AdministratorSystem",
      path: "system",
      meta: {
        nameDrawer: messages[lang].system,
        operator: true,
        icon: "mdi-developer-board",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator/system/"),
      children: [
        {
          // AdministratorNotifications INDEX
          name: "AdministratorNotifications",
          path: "administratorNotifications",
          redirect: {
            name: "AdministratorSystemNotifications",
          },
          meta: {
            nameDrawer: messages[lang].notifications,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/administrator/system/notifications/"),
          // Antiga principal
          children: [
            //AdministratorSystemNotifications notifications
            {
              name: "AdministratorSystemNotifications",
              path: "notifications/system",
              meta: {
                nameDrawer: messages[lang].system,
                operator: true,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/system/notifications/systemNotifications/notifications/"
                ),
              children: [
                {
                  name: "AdministratorSystemNotification",
                  path: "notification/:id",
                  meta: {
                    nameDrawer: messages[lang].notification,
                    operator: true,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/system/notifications/systemNotifications/notification"
                    ),
                },
              ],
            },
            {
              name: "AdministratorFinalUserNotifications",
              path: "notifications/notifications",
              meta: {
                nameDrawer: messages[lang].users,
                operator: true,
                filters: ["Range"],
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/administrator/system/notifications/usersNotifications/"
                ),
              children: [
                {
                  name: "AdministratorUserNotificationAdd",
                  path: "new-message",
                  meta: { nameDrawer: messages[lang].newMessage },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/system/notifications/usersNotifications/addNotification"
                    ),
                },
                {
                  name: "AdministratorUserNotificationSee",
                  path: "see-message",
                  meta: { nameDrawer: messages[lang].seeNotification },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/system/notifications/usersNotifications/seeNotification"
                    ),
                },
                // {
                //   name: "AdministratorUserNotificationEdit",
                //   path: "edit-message",
                //   meta: { nameDrawer: messages[lang].editMessage },
                //   component: () => import(
                //     '@/views/backoffice/administrator/system/notifications/usersNotifications/editNotification'
                //   ),
                // },
                {
                  name: "AdministratorUserNotificationDelete",
                  path: "delete-message",
                  meta: { nameDrawer: messages[lang].deleteMessage },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/system/notifications/usersNotifications/deleteNotification"
                    ),
                },
              ],
            },
          ],
        },
        {
          name: "AdministratorSystemInvoices",
          path: "invoices",
          beforeEnter: (to, from, next) => {
            if (to.name === "AdministratorSystemInvoices") {
              next("/administrator/system/invoices/newInvoices");
            } else {
              next();
            }
          },
          meta: {
            nameDrawer: messages[lang].invoices,
            operator: true,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/system/invoices/index.vue"
            ),
          children: [
            {
              name: "AdministratorNewInvoices",
              meta: {
                nameDrawer: messages[lang].newInvoices.name,
              },
              path: "newInvoices",
              component: () =>
                import(
                  "@/views/backoffice/administrator/system/invoices/newInvoices.vue"
                ),
            },
            {
              name: "AdministratorOldInvoices",
              path: "oldInvoices",
              meta: {
                nameDrawer: messages[lang].newInvoices.oldInvoices,
              },
              children: [
                {
                  name: "AdministratorSystemInvoicesInvoice",
                  path: "invoice/:id_invoice",
                  meta: {
                    nameDrawer: messages[lang].invoice,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/administrator/system/invoice.vue"
                    ),
                },
              ],
              component: () =>
                import(
                  "@/views/backoffice/administrator/system/invoices/oldInvoices.vue"
                ),
            },
          ],
        },
        // LOGS
        {
          name: "AdministratorSystemSearchLogs",
          path: "Logs",
          meta: {
            nameDrawer: messages[lang].consultLogs,
            operator: true,
            filters: [
              "Range",
              "SelectUserLogLevel",
              "SelectActionLog",
              "InputStringLog",
              "GroupExport",
              // "AutocompletePlayers",
            ],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/administrator/system/searchLogs.vue"),
        },
        // LOGS
        {
          name: "AdministratorSystemActionsContributors",
          path: "administratorSystemActionsContributors",
          meta: {
            nameDrawer: messages[lang].actionsContributors,
            operator: true,
          },
          component: () =>
            import(
              "@/views/backoffice/administrator/system/actionsContributors.vue"
            ),
        },
      ],
    },

    //  =================================================================
    //  Group: Account
    //  =================================================================
    {
      name: "AdminAccount",
      path: "account",
      meta: {
        nameDrawer: messages[lang].account,
        operator: true,
        icon: "mdi-badge-account-horizontal",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "AdministratorAccountChangePassword",
          path: "changePassword",
          meta: {
            nameDrawer: messages[lang].changePassword,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/shared/account/changePassword.vue"),
        },
      ],
    },
  ],
};
